import { render } from "./Illustration.vue?vue&type=template&id=67e6354a&scoped=true"
import script from "./Illustration.vue?vue&type=script&lang=js"
export * from "./Illustration.vue?vue&type=script&lang=js"

import "./Illustration.vue?vue&type=style&index=0&id=67e6354a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67e6354a"]])

export default __exports__